import { render, staticRenderFns } from "./HealthrecordsEdit.vue?vue&type=template&id=7a2c79fc&"
import script from "./HealthrecordsEdit.vue?vue&type=script&lang=js&"
export * from "./HealthrecordsEdit.vue?vue&type=script&lang=js&"
import style0 from "./HealthrecordsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports